// utils/seedReleaseVersions.js
// Seed initial version/release history
import { createVersionEntry, getAllVersions } from "./releaseVersions";
import { APP_VERSION } from "../version";

/**
 * Seed initial version entries based on current version and historical context
 */
export async function seedInitialVersions() {
  try {
    // Check if versions already exist
    const existingVersions = await getAllVersions();
    if (existingVersions.length > 0) {
      console.log("✅ Versions already exist, skipping seed");
      return;
    }

    // Create current version entry
    const today = new Date();
    await createVersionEntry({
      version: APP_VERSION || "2.0.89",
      releaseDate: today,
      changes: [
        {
          type: "enhancement",
          description: "Bug and Enhancement Tracking System - comprehensive admin log viewer with version history",
        },
        {
          type: "enhancement",
          description: "Player reconnection system with state persistence and auto-restore",
        },
        {
          type: "bug",
          description: "Fixed duplicate onSnapshot listeners causing memory leaks in Player.js",
        },
        {
          type: "bug",
          description: "Added error handling to all Firebase onSnapshot calls",
        },
        {
          type: "bug",
          description: "Fixed MULTIANSWER question selection issues with dynamic maxSelectable",
        },
        {
          type: "enhancement",
          description: "Added keyboard shortcut 'o' to open Quiz Options popup on display",
        },
      ],
      notes: "Initial version tracking system implemented. This version includes fixes for player crashes and reconnection functionality.",
      createdBy: "system",
    });

    // Create a placeholder for previous major version
    const previousDate = new Date(today);
    previousDate.setMonth(previousDate.getMonth() - 1);
    await createVersionEntry({
      version: "2.0.0",
      releaseDate: previousDate,
      changes: [
        {
          type: "other",
          description: "Major version 2.0 release - base quizmaster functionality",
        },
      ],
      notes: "Historical placeholder - version tracking system not yet implemented",
      createdBy: "system",
    });

    console.log("✅ Initial version entries created successfully");
  } catch (err) {
    console.error("❌ Error seeding initial versions:", err);
    throw err;
  }
}

/**
 * Check if versions need seeding
 */
export async function shouldSeedVersions() {
  try {
    const versions = await getAllVersions();
    return versions.length === 0;
  } catch {
    return false;
  }
}
